import React from "react";
import { cn } from "@/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-primary/10", className)}
      {...props}
    />
  );
}

interface CardSkeletonProps {
  rows?: number;
  showProfile?: boolean;
  className?: string;
}

function CardSkeleton({
  rows = 5,
  showProfile = true,
  className,
}: CardSkeletonProps) {
  return (
    <div className={cn(className)}>
      {/* Profile section skeleton */}
      {showProfile && (
        <div className='flex items-center gap-3 mb-6'>
          <Skeleton className='w-10 h-10 rounded-full flex-shrink-0' />
          <Skeleton className='h-4 w-32' />
        </div>
      )}

      {/* Data rows skeleton */}
      <div className='space-y-3'>
        {Array(rows)
          .fill(0)
          .map(() => (
            <div key={crypto.randomUUID()} className='flex items-center gap-3'>
              <Skeleton className='w-5 h-5 rounded-full flex-shrink-0' />
              <div className='flex-1 flex justify-between items-center gap-4'>
                <Skeleton className='h-3 w-28 flex-shrink-0' />
                <Skeleton className='h-3 w-20 flex-shrink-0' />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export { Skeleton, CardSkeleton };
